import React, { useEffect } from "react"

import { useScript } from "../../../helpers"

const AdsByGoogle = () => {
    useScript("https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2111302653902282", { crossorigin: "anonymous" })

    useEffect(() => {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
    }, [])

    return (
        <ins className="adsbygoogle"
            style={{ display: "block" }}
            data-ad-format="autorelaxed"
            data-ad-client="ca-pub-2111302653902282"
            data-ad-slot="6145818058" />
    )
}

export default AdsByGoogle
